import React from "react";
import { useSelector } from "react-redux";
import { ReceiptMatchingWidget } from "@qgiv/core-donor";
import { selectAllFormSettings } from "../../redux/slices/formSettingsSlice";
import { selectReceipt } from "../../redux/slices/receiptSlice";

const ConnectedReceiptMatchingWidget = () => {
    const formSettings = useSelector(selectAllFormSettings);
    const {
        matchingTokens = {},
        thirdPartyMatching,
        enableMatching,
    } = formSettings;
    const receipt = useSelector(selectReceipt);

    const {
        transaction: { matchingData = {}, email = "", company = "" },
    } = receipt;

    const { companyId = "", companyName = "", matchId = "" } = matchingData;

    // -------------------------------------------------------------------------
    // TODO: The original layout of this code seemed to indicate that an evaluation
    // was expected to determine if the value of `matchingProps` was an empty object
    // or the value that is created below. This will be something we need to test
    // when the redux upgrade is complete.
    // -------------------------------------------------------------------------

    const matchingProps = {
        matchId,
        companyId,
        companyName,
        email,
        company,
    };

    const receiptMatchingWidgetProps = {
        enableMatching,
        ...matchingProps,
        matchingTokens,
        thirdPartyMatching,
    };

    return <ReceiptMatchingWidget {...receiptMatchingWidgetProps} />;
};

export default ConnectedReceiptMatchingWidget;
